import { useParams } from "react-router-dom";
import { HiInformationCircle, HiCog, HiUsers } from "react-icons/hi";
import { useRoleInfo } from "../_context/RoleinfoContext";
import Sidebar from "components/Sidebar/Sidebar";
import { useTranslation } from "react-i18next";

const RoleSidebar = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { roleInfo } = useRoleInfo();

  const items = [
    {
      path: `/dashboard/roles/${id}`,
      label: t("roles.roleInfo.sidebar.info"),
      icon: <HiInformationCircle className="h-5 w-5" />,
    },
    {
      path: `/dashboard/roles/${id}/users`,
      label: t("roles.roleInfo.sidebar.users"),
      icon: <HiUsers className="h-5 w-5" />,
    },
    {
      path: `/dashboard/roles/${id}/settings`,
      label: t("roles.roleInfo.sidebar.settings"),
      icon: <HiCog className="h-5 w-5" />,
    },
  ];

  const isActiveItems = (itemPath: string) => {
    const currentPath = window.location.pathname;
    if (currentPath === itemPath) return true;
    if (itemPath === `/dashboard/roles/${id}`) {
      return currentPath === `/dashboard/roles/${id}/`;
    }
    return false;
  };

  const ProfileSection = (
    <div className="flex flex-col items-center justify-center   px-6 py-5">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-navy-700 dark:text-white">
          {roleInfo?.name}
        </h3>
      </div>
    </div>
  );

  return (
    <Sidebar
      items={items}
      isActiveItems={isActiveItems}
      ProfileSection={ProfileSection}
    />
  );
};

export default RoleSidebar;
